import React, {useEffect, useState} from "react";
import {Container, Typography} from "@material-ui/core"
import PropTypes from "prop-types";
import {useStyles} from "./styles";
import SquareChip from "../../../../SquareChip";
import LPREye from "../LPREye";
import DetailsValueRow from "../DetailsValueRow";
import useCancellationToken from "../../../../../hooks/useCancellationToken";
import {useEnqueueSnackbar} from "../../../../../hooks/useEnqueueSnackbar";
import InventoryService from "../../../../../services/InventoryService";
import apiClient from "../../../../../auth/apiClient";
import Skeleton from "@material-ui/lab/Skeleton";
import ContractService from "../../../../../services/ContractService";
import CredentialStatusChange from "../Form/CredentialStatusChange";
import clsx from "clsx";
import useHasPermissions from "../../../../../hooks/useHasPermissions";
import {useInventoryDrawerFormContext} from "../Form/InventoryDrawerFormProvider";

const inventoryService = new InventoryService(apiClient);
const contractService = new ContractService(apiClient);

const PrepaidDetails = ({contextID, onLPRSave}) => {
  const classes = useStyles();
  const enqueueSnackbar = useEnqueueSnackbar();
  const [loading, setLoading] = useState(false);
  const [prepaidDetails, setPrepaidDetails] = useState(null);
  const {hasPermissions} = useHasPermissions();
  const inventoryEditPermissions = hasPermissions(["inventory.edit"]);
  const {
    state: {canSave, saveClicked, status, reason},
    actions: {saveSuccess, setDefaultStatus}
  } = useInventoryDrawerFormContext();

  useEffect(() => {
    if (contextID) {
      executeDetailsQuery();
    }
  }, [contextID])

  const {execute: executeDetailsQuery} = useCancellationToken({
    func: async ({cancelToken}) => {
      setLoading(true);
      const res = await inventoryService.getPrepaidDetails(contextID, cancelToken);
      setLoading(false);
      setPrepaidDetails(res.data);
      setDefaultStatus(res.data.status.toLowerCase());
    },
    errHandleFunc: () => {
      setLoading(false);
      enqueueSnackbar("Failed to load details", {
        variant: "error",
        tag: "FailedToLoadDetails",
      });
    },
  });
  useEffect(() => {
    if (saveClicked && canSave) {
      handleAccessHolderStatusChange(status, reason);
    }
  }, [saveClicked]);

  const handleAccessHolderStatusChange = async (status, reason) => {
    try {
      await contractService.updateAccessHolderStatus(contextID, {
        status: status,
        reason: reason
      });
      setPrepaidDetails({...prepaidDetails, status: status})
      saveSuccess(status)
    } catch {
      enqueueSnackbar("Failed to update prepaid pass", {
        variant: "error",
        tag: "FailedToUpdatePrepaidPass"
      });
    }
  };

  const handleLPRClose = (isLPRSaved) => {
    if (!isLPRSaved) {
      return;
    }
    executeDetailsQuery();
    onLPRSave();
  }

  return <>
    {loading ?
      <Container>
        <Skeleton className={classes.skeleton} variant="rect" height="2rem" animation="wave"/>
        <Skeleton className={classes.skeleton} variant="rect" height="2rem" animation="wave"/>
        <Skeleton className={classes.skeleton} variant="rect" height="2rem" animation="wave"/>
      </Container>
      :
      <>
        {prepaidDetails !== null && (
          <>
            <DetailsValueRow title="Status">
              {inventoryEditPermissions && prepaidDetails.status ? (
                <CredentialStatusChange/>
              ) : (
                <Typography variant="h6" data-value={prepaidDetails.status}>
                  {prepaidDetails.status}
                </Typography>
              )}
            </DetailsValueRow>
            <DetailsValueRow title="Access Holder" thin={true} titleSize={6} valueSize={6}>
              <Typography>{prepaidDetails?.firstName} {prepaidDetails?.lastName}</Typography>
            </DetailsValueRow>
            <DetailsValueRow title="Credential" thin={true}>
              <Typography>{prepaidDetails?.credentialReference}</Typography>
            </DetailsValueRow>

            {prepaidDetails.plate && (
              <DetailsValueRow title="Plate" thin={true}> <span>
                <SquareChip mode="warning" text={prepaidDetails.plate.read}/>
                {
                  prepaidDetails.plate.hasImages &&
                  <LPREye lprPlateText={prepaidDetails.plate.read} lprID={prepaidDetails.plate.lprId}
                    onClose={handleLPRClose} />
                }
              </span>
              </DetailsValueRow>
            )}
          </>
        )}
      </>
    }
  </>
    ;
};

PrepaidDetails.defaultProps = {
  contextID: null,
  onLPRSave: () => {
  }
};
PrepaidDetails.propTypes = {
  contextID: PropTypes.string,
  onLPRSave: PropTypes.func
};

export default PrepaidDetails;
